/*添加服务*/
define('services/mysetting/bank.select.service',['app', 'mainCons'], function (app, mainCons) {
    return app.factory('bankSelectService', ['ngDialog', '$state', '$q', 'OpenOther', 'auiDialog', 'OpenUp', function (ngDialog, $state, $q, OpenOther, auiDialog, OpenUp) {

        //查询总行,bankType = 0 境内付款银行 1 跨境付款银行
        function getBanks(bankType, callback) {
            OpenUp.getBankList({ req: {
                countryAlpha2Code: 'CN',
                bankType: bankType
            }

            }).then(function (res) {

                if (res && res.bankList) {

                    res.bankList.sort(function (a, b) {
                        return b.priority - a.priority
                    });

                    var banks = [];
                    for (var i = 0; i < res.bankList.length; i++) {
                        banks.push({key: res.bankList[i].bankName, value: res.bankList[i].bankName});
                    }
                    callback(banks);
                }
            }).catch(function () {
                var banks = [];
                callback(banks);
            });
        }
        function getBanksEn(bankType,country, callback) {
            OpenUp.getBankList({ req: {
                    countryAlpha2Code: country,
                    bankType: bankType
                }

            }).then(function (res) {

                if (res && res.bankList) {

                    res.bankList.sort(function (a, b) {
                        return b.priority - a.priority
                    });

                    var banks = [];
                    for (var i = 0; i < res.bankList.length; i++) {
                        banks.push({key: res.bankList[i].bankName, value: res.bankList[i].bankName});
                    }
                    callback(banks);
                }
            }).catch(function () {
                var banks = [];
                callback(banks);
            });
        }

        function setBanks(data) {
            var banks = [];
            if (data.bankList) {
                for (var i = 0; i < data.bankList.length; i++) {
                    banks.push({key: data.bankList[i], value: data.bankList[i]});
                }
            }
            return banks;
        }

        //查询总行所在省
        function getBankBranchRegions(bank, callback) {
            OpenUp.getBankProvinceList({ req: {
                countryAlpha2Code: 'CN',
                bankName: bank
            }

            }).then(function (res) {
                if (res && res.provinceList) {
                    var banks = [];
                    for (var i = 0; i < res.provinceList.length; i++) {
                        banks.push({key: res.provinceList[i].shortNameCn, value: res.provinceList[i].shortNameCn});
                    }
                    callback(banks);
                }
            }).catch(function () {
                var banks = [];
                callback(banks);
            });
        }

        function setBankBranchRegions(data) {
            var provices = [];
            if (data.provinceList) {
                for (var i = 0; i < data.provinceList.length; i++) {
                    var provice = data.provinceList[i];
                    var cities = [];
                    if (provice.cityList) {
                        for (var j = 0; j < provice.cityList.length; j++) {
                            cities.push({key: provice.cityList[j], value: provice.cityList[j]});
                        }
                    }
                    provices.push({key: provice.province, value: provice.province, cities: cities});
                }
            }
            return provices;
        }

        //查询银行省所在市
        function getBankBranchRegionsCity(bank, province, callback) {
            OpenUp.getBankCityList({ req: {
                countryAlpha2Code: 'CN',
                bankName: bank,
                provinceName: province
            }
            }).then(function (res) {
                if (res && res.cityList) {
                    var banks = [];
                    for (var i = 0; i < res.cityList.length; i++) {
                        banks.push({key: res.cityList[i].chineseName, value: res.cityList[i].chineseName});
                    }
                    callback(banks);
                }
            }).catch(function () {
                var banks = [];
                callback(banks);
            });
        }

        //查询分行
        function getBankBranchs(bank, province, city, callback,countryAlpha2Code) {
            OpenUp.getBranchList({
                req: {
                    countryAlpha2Code: (countryAlpha2Code?countryAlpha2Code:'CN'),
                    bankName: bank,
                    provinceName: province,
                    cityName: city
                }
            }).then(function (res) {
                if (res && res.bankList) {
                    res.bankList.sort(AUI.BaseJSUtil.arrObjCompare('branchName'));
                    var banks = [];
                    for (var i = 0; i < res.bankList.length; i++) {
                        var tmp = angular.copy(res.bankList[i]);
                        tmp.key = res.bankList[i].branchName;
                        tmp.value = res.bankList[i].branchName;
                        banks.push(tmp);
                    }
                    callback(banks);
                }
            }).catch(function () {
                var banks = [];
                callback(banks);
            });
        }
        function getBankBranchsEN(bank, province, city, callback,countryAlpha2Code) {
            getBankBranchs(bank, province, city, callback,countryAlpha2Code)
        }



        function setBankBranchs(data) {
            var bankBranchs = [];
            if (data.branchList) {
                for (var i = 0; i < data.branchList.length; i++) {
                    bankBranchs.push({key: data.branchList[i], value: data.branchList[i]});
                }
            }
            return bankBranchs;
        }


        function getBankBranchsByBranch(branch, swiftCode, callback, country) {
            var req = {countryAlpha2Code: !country ? 'CN' : country};
            branch && (req['branchNumer'] = branch);
            swiftCode && (req['swiftCode'] = swiftCode);
            OpenUp.getBranchList({
                req: req
            }).then(function (res) {
                if (res && res.bankList) {
                    callback(res.bankList);
                }else{
                    callback([]);
                }
            }).catch(function () {
                var banks = [];
                callback(banks);
            });
        }

        function showSearchDlg(args) {
            !args && (args = {});
            var handler = ngDialog.open({
                template: 'pages/mysetting/search.bank.html',
                className: '',
                closeByEscape: false,
                closeByDocument: false,
                overlay: false,
                controller: ['$scope', '$timeout', function ($scope, $timeout) {
                    var Model = $scope.Model = {
                        banks: [],
                        branchNumber: args.initBranchNumber,
                        swiftCode: args.initswiftCode,
                        noData: '暂无数据',
                        selected: null,
                        isCN: args.isCN,
                        country: args.country,
                        countryName: args.countryName
                    };
                    //初始化查询,只查询一次
                    var G = {queryOnce: false};
                    searchBranch();

                    $scope.searchBranch = searchBranch;
                    $scope.selectBranch = selectBranch;
                    function searchBranch() {
                        $scope.queryBankForm && $scope.queryBankForm.branchNumber && $scope.queryBankForm.branchNumber.$setDirty();
                        $scope.queryBankForm && $scope.queryBankForm.swiftCode && $scope.queryBankForm.swiftCode.$setDirty();
                        if ($scope.queryBankForm && $scope.queryBankForm.$valid || (!G.queryOnce && (Model.branchNumber || Model.swiftCode))) {
                            G.queryOnce = true;
                            getBankBranchsByBranch(Model.branchNumber, Model.swiftCode, function (banks) {
                                var bks = [];
                                if (!Model.isCN && Model.country == 'CN') {
                                    angular.forEach(banks, function (v) {
                                        angular.forEach(sysParamCfg.bankENs, function (sv) {
                                            if (v.bankName.trim().toUpperCase() == sv.key.trim().toUpperCase()) {
                                                bks.push(v);
                                            }
                                        });
                                    });
                                } else {
                                    bks = banks;
                                }
                                if (!bks || !bks.length) {
                                    Model.selected = null;
                                }
                                bks && angular.forEach(bks, function (v, idx) {
                                    v.id = parseInt(idx) + 1;
                                });
                                Model.banks = bks;
                            }, Model.country);
                        }
                    }

                    function selectBranch(data) {
                        Model.selected = data.id;
                    }

                    //关闭页面
                    Model.close = function () {
                        handler.close();
                    };
                    //保存
                    Model.doSubmit = function () {
                        if ($scope.queryBankForm.$valid && Model.selected) {
                            var selectBranch = null;
                            angular.forEach(Model.banks, function (v, idx) {
                                if (Model.selected == v.id) {
                                    selectBranch = angular.copy(v);
                                }
                            });
                            args.callBack && selectBranch && (args.callBack(selectBranch) , Model.close());
                        }
                    };

                }]
            });
        }

        function showConfirmDlg(args) {
            var defer = $q.defer();
            !args && (args = {});
            var isBankChangeCN = false, isBankChangeEN = false;
            //离岸银行改变逻辑
            if(args.isOffSite){
                isBankChangeEN = isChangeBank4OffSite(args.oldBankEN,args.bankEN,args.selectCountryCfg);
            }else {
                isBankChangeEN = isChangeBank(args.oldBankEN, args.bankEN, args.bankSelectedEN);
            }
            isBankChangeCN = isChangeBank(args.oldBankCN, args.bankCN, args.bankSelectedCN,args.isChangemercShortName);
            //银行未变更不弹框
            if (!isBankChangeCN && !isBankChangeEN && !args.isReVer) {
                defer.resolve();
                return defer.promise;
            }
            //重新实名认证不修改也给弹出二次确认框
            args.isReVer && args.bankSelectedCN && (isBankChangeCN = true);
            args.isReVer && args.bankSelectedEN && (isBankChangeEN = true);

            var handler = ngDialog.open({
                template: 'pages/mysetting/confirm.bank.html',
                className: '',
                closeByEscape: false,
                closeByDocument: false,
                overlay: false,
                controller: ['$scope', '$q', function ($scope, $q) {
                    var Model = $scope.Model = {
                        bankCN: args.bankCN,
                        bankEN: args.bankEN,
                        oldBankCN: args.oldBankCN,
                        oldBankEN: args.oldBankEN,
                        bankSelectedCN: args.bankSelectedCN,
                        bankSelectedEN: args.bankSelectedEN,
                        isBankChangeCN: isBankChangeCN,
                        isBankChangeEN: isBankChangeEN,
                        selectCountryCfg: args.selectCountryCfg,
                        isOffSite: args.isOffSite,
                        checkValue: 0, //默认选中check
                        branchNumbeToNewNameByCountry: mainCons.modUserinfoConstant.branchNumbeToNewNameByCountry,
                        mercShortName:args.mercShortName
                    }
                    //离岸币种特殊处理
                    args.isOffSite && (Model.currency = (args.bankEN.currency != 'USD' && args.bankEN.currency != 'JPY' && args.bankEN.currency != 'HKD' && args.bankEN.currency != 'GBP') ? 'EUR' : args.bankEN.currency);
                    //关闭页面
                    Model.close = function () {
                        handler.close();
                        defer.reject();
                    };
                    //保存
                    Model.doSubmit = function () {
                        if (Model.checkValue != 1) {
                            return;
                        }
                        handler.close();
                        defer.resolve();
                    };
                }]
            });
            return defer.promise;
        }

        function isChangeBank(o, n, bankSelected,isChangemercShortName) {
            var changed = false;
            if(!n || !o || !bankSelected){
                return changed;
            }
            if(o.bankAccount != n.bankAccount && n.bankAccount != n.bankAccountFuzzy){
            	return true;
            }
            // 商户简称改变
            if(isChangemercShortName){
                return true;
            }
            var attrs = ["country.value", "bank.value", "branch.value", "branchNumber", "swiftCode", "accountName", "currency","accountCurrencys","legalManVideoUrl"];
            changed = bankSelected && isPropertyChange(o, n, attrs);
            return changed;
        }
        
        function isChangeBank4OffSite(o, n, cfg) {
            var changed = false;
            if(!n || !o || !cfg){
                return changed;
            }
            if(o.countryName != n.countryName){
                changed = true;
            }
            if (cfg.bankName.showFlag && (!o.bank || o.bank.value != n.bank.value)) {
                changed = true;
            }
            if(cfg.bankNumber.showFlag && o.bankNumber != n.bankNumber){
                changed = true;
            }
            if (cfg.branchName.showFlag && (!o.branch || o.branch.value != n.branch.value)) {
                changed = true;
            }
            if(cfg.branchNumber.showFlag && o.branchNumber != n.branchNumber){
                changed = true;
            }
            if(cfg.swiftCode.showFlag && o.swiftCode != n.swiftCode){
                changed = true;
            }
            if(cfg.accountName.showFlag && o.bankAcctName != n.accountName){
                changed = true;
            }
            if(cfg.iban.showFlag && o.iban != n.iban){
                changed = true;
            }
            if(cfg.accountNumber.showFlag && o.bankAccount != n.bankAccount && n.bankAccount != n.bankAccountFuzzy){
                changed = true;
            }
            if(o.currency != n.currency){
                changed = true;
            }
            if(cfg.accountType.showFlag && o.accountType != n.accountType){
                changed = true;
            }
            if(cfg.kc.showFlag && o.kc != n.kc){
                changed = true;
            }
            if(cfg.taxPayerID.showFlag && o.taxPayerId != n.taxPayerId){
                changed = true;
            }
            if(cfg.attribute4.showFlag && o.attribute4 != n.attribute4){
                changed = true;
            }
            if(cfg.city.showFlag && o.hCity != n.hCity){
                changed = true;
            }
            if(cfg.branchAddress.showFlag && o.branchAddress != n.branchAddress){
                changed = true;
            }
            return changed;
        }

        function isPropertyChange(o,n,attrs){
            var eq = true;
            angular.forEach(attrs,function(v, idx){
                var nV,oV;
                if(v.indexOf(".") > -1){
                    var pre = v.substring(0,v.indexOf("."));
                    var sub = v.substring(pre.length+1);
                    nV = n[pre] ? n[pre][sub] : null;
                    oV = o[pre]? o[pre][sub]: null;
                }else{
                    nV = n[v];
                    oV = o[v];
                }
                if(!(nV && nV == oV || !nV && !oV) ){
                    eq = eq && false;
                }
            });
            return !eq;
        }

        function handleAfterGetBankBranchs(Model,data,branch,fl) {
            Model.branchs = data;
            var flag = false;
            var branchTemp;
            for (var o in data) {
                if (branch == data[o].value) {
                    flag = true;
                    branchTemp = data[o];
                    break;
                }
            }
            if (!flag && fl) {
                Model.isShowNomatchBranch = true;
            }
            // 如果指定了支行信息，则获取到对应的支行号，从getBankBranchs中会自动带出来。
            if (branchTemp) {
                // 获取
                Model.bankInfoCN.branchNumber = branchTemp.branchNumber;
            }
        }
        return {
            'getBanks': getBanks,
            'getBanksEn':getBanksEn,
            'getBankBranchRegions': getBankBranchRegions,
            'getBankBranchRegionsCity': getBankBranchRegionsCity,
            'getBankBranchs': getBankBranchs,
            'showSearchDlg': showSearchDlg,
            'showConfirmDlg': showConfirmDlg,
            'getBankBranchsEN':getBankBranchsEN,
            'handleAfterGetBankBranchs':handleAfterGetBankBranchs,
            'isChangeBank4OffSite':isChangeBank4OffSite
        }
    }]);
});

